import React from 'react';
import { BookOpen, ArrowRight } from 'lucide-react';
import { useDbNavigate } from '../../context/DatabaseContext';
import { SUPPORTING_DOCS_GROUPS } from './supportingDocsConfig';

const SupportingDocsDashboardPage = () => {
  const navigate = useDbNavigate();

  return (
    <div className="page-container" style={{ padding: '20px' }}>
      <div style={{
        display: 'flex', alignItems: 'center',
        padding: 'var(--spacing-sm) var(--spacing-md)',
        backgroundColor: 'var(--color-bg-white)',
        borderBottom: '1px solid var(--color-gray-200)',
        marginBottom: 'var(--spacing-lg)'
      }}>
        <BookOpen size={20} style={{ marginRight: '8px', color: 'var(--color-primary)' }} />
        <h1 style={{ margin: 0, fontSize: 'var(--text-lg)', color: 'var(--color-primary)' }}>
          Supporting Documentation
        </h1>
        <span style={{ marginLeft: '12px', fontSize: 'var(--text-sm)', color: 'var(--color-gray-500)' }}>
          {SUPPORTING_DOCS_GROUPS.length} groups
        </span>
      </div>

      <div style={{
        display: 'flex', alignItems: 'center', gap: '8px',
        marginBottom: 'var(--spacing-md)',
        paddingBottom: 'var(--spacing-sm)',
        borderBottom: '2px solid var(--color-primary)'
      }}>
        <BookOpen size={16} style={{ color: 'var(--color-primary)' }} />
        <span style={{
          fontSize: 'var(--text-base)',
          fontWeight: 700,
          color: 'var(--color-primary)',
          fontFamily: "'Rajdhani', 'Roboto Condensed', sans-serif",
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }}>
          Reference Data
        </span>
        <span style={{ fontSize: 'var(--text-xs)', color: 'var(--color-gray-400)' }}>
          {SUPPORTING_DOCS_GROUPS.length} groups available
        </span>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
        gap: 'var(--spacing-md)'
      }}>
        {SUPPORTING_DOCS_GROUPS.map(group => (
          <div
            key={group.id}
            onClick={() => navigate(`/${group.route}`)}
            style={{
              background: 'var(--color-bg-white)',
              border: '1px solid var(--color-gray-200)',
              borderRadius: '6px',
              padding: 'var(--spacing-md) var(--spacing-lg)',
              cursor: 'pointer',
              transition: 'border-color 0.15s, box-shadow 0.15s',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = 'var(--color-primary)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = 'var(--color-gray-200)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{
                fontSize: 'var(--text-base)',
                fontWeight: 600,
                color: 'var(--color-primary)',
                fontFamily: "'Rajdhani', 'Roboto Condensed', sans-serif",
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                {group.label}
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ fontSize: 'var(--text-xs)', color: 'var(--color-gray-400)' }}>
                  {group.items.length} {group.items.length === 1 ? 'item' : 'items'}
                </span>
                <ArrowRight size={16} style={{ color: 'var(--color-gray-400)', flexShrink: 0 }} />
              </div>
            </div>
            <p style={{
              margin: 0,
              fontSize: 'var(--text-sm)',
              color: 'var(--color-gray-600)',
              lineHeight: 1.5
            }}>
              {group.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SupportingDocsDashboardPage;
